import React from 'react'
import { MaoButton } from '../../styles/products'
import { CommentIcon } from '../../styles/icons'

type Props = {
  isSticky?: boolean
  onClick: (...args: Array<any>) => any
  sku: string
  updateDataLayer: (...args: Array<any>) => any
}

const Component = (props: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const { isSticky, onClick, sku, updateDataLayer } = props

  const goToMao = () => {
    window.location.href = `/offer/${sku}`
  }

  return (
    <MaoButton
      data-button='mao'
      onClick={() => {
        onClick()
        updateDataLayer({
          event: 'PDP MAO',
          prompt: isSticky ? 'sticky bar' : 'inline',
        })
        goToMao()
      }}
      title='Make an offer to artist'
    >
      <CommentIcon />
      <p
        className={isSticky ? 'defaultTypographySmall' : 'defaultTypographyMedium'}
        style={{ color: isSticky ? '#333' : '#ffffff', margin: 0 }}
      >
        Make an Offer
      </p>
    </MaoButton>
  )
}

export default Component
